import { ORACLE_ENGINE } from "./sql-connection-engines";
import { createSqlConnectionForm } from "./sql-connection-form";

/** Oracle. Everything but the engine spec lives in `sql-connection-form.tsx`. */
const createConnectionOracle = createSqlConnectionForm(ORACLE_ENGINE);
export { createConnectionOracle as CreateConnectionOracle };
